import { render, staticRenderFns } from "./AccessManager.vue?vue&type=template&id=8c18a528&scoped=true&"
import script from "./AccessManager.vue?vue&type=script&lang=js&"
export * from "./AccessManager.vue?vue&type=script&lang=js&"
import style0 from "./AccessManager.vue?vue&type=style&index=0&id=8c18a528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c18a528",
  null
  
)

export default component.exports